<template>
  <div class="d-flex flex-column result-display">
    <div class="sortition-name text-center text-black">
      {{ result.sortition.name }}
    </div>
    <div class="sortition-date text-center text-black">{{ result.date }}</div>
    <v-row no-gutters>
      <v-col md="6" lg="6" class="align-self-center border-right">
        <v-row no-gutters>
          <v-col>
            <result-digit-display
              :value="result.first"
              text="1st"
              left
            ></result-digit-display>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <result-digit-display
              :value="result.second"
              text="2nd"
              left
            ></result-digit-display>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <result-digit-display
              :value="result.third"
              text="3rd"
              left
            ></result-digit-display>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="6" lg="6">
        <v-row no-gutters>
          <v-col cols="12">
            <v-img height="30" contain :src="require('assets/static/img/picks/hotpicklotto/pick2.png')" />
          </v-col>
          <v-col cols="12">
            <result-digit-display
              class="d-flex justify-center"
              :value="result.pickTwo"
            ></result-digit-display>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <v-img height="30" contain :src="require('assets/static/img/picks/hotpicklotto/pick3.png')" />
          </v-col>
          <v-col cols="12">
            <result-digit-display
              class="d-flex justify-center"
              :value="result.cashThree"
            ></result-digit-display>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <v-img height="30" contain :src="require('assets/static/img/picks/hotpicklotto/pick4.png')" />
          </v-col>
          <v-col cols="12">
            <result-digit-display
              class="d-flex justify-center"
              :value="result.pickFour"
            ></result-digit-display>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <v-img height="30" contain :src="require('assets/static/img/picks/hotpicklotto/pick5.png')" />
          </v-col>
          <v-col cols="12">
            <result-digit-display
              class="d-flex justify-center"
              :value="result.pickFive"
            ></result-digit-display>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ResultDigitDisplay from "./ResultDigitDisplay.vue";

export default {
  name: "ResultDisplay",
  components: { ResultDigitDisplay },
  props: {
    result: {
      type: Object,
      required: true
    }
  }
};
</script>
<style scoped lang="scss">
@import "css/variables";

.sortition-name {
  line-height: 20px;
  font-size: 1.4rem;
  font-weight: bold;
}

.text-black {
  color: $yellow;
}

.next-drawing-text {
  color: black;
  border-bottom: 5px black solid;
}

.sortition-date {
  font-size: 1rem;
}

.first,
.second,
.third {
  display: flex;
  flex-direction: column;
  margin-top: 0;

  .header {
    line-height: 28px;
    text-align: center;
  }
}
.border-right {
  border-right: black 5px solid;
  padding-right: 14px;
}
</style>
